class Footer {
  constructor() {
    this.init();
  }

  init() {
    this.handleSubmit()
    this.handleSend();
    this.handleCustomWorkSelect();
    this.handleButtonBack();
  }

  handleSubmit() {
    const forms = document.querySelectorAll('.contact-form');

    forms?.forEach((form) => {
      const footerWrap = form.querySelector('.contact-form__footer-wrap')
      const button = form.querySelector('.wpcf7-form .btn')
      const checkmark = form.querySelector('.checkmark')

      footerWrap?.addEventListener('click', () => {
        const isActive = footerWrap.classList.toggle('active');

        button?.classList.toggle('disabled', !isActive);
        checkmark?.classList.toggle('active', isActive);
      });
    })
  }

  handleSend() {
    const forms = document.querySelectorAll('.modal-form')

    document.addEventListener('wpcf7mailsent', function(event) {
      forms?.forEach((form) => {
        form.classList.add('success')

        const title = form.querySelector('.form-title')
        const description = form.querySelector('.form-description')

        if (title) {
          const titleSuccess = title.dataset.success

          if (titleSuccess) {
            title.textContent = titleSuccess
          }
        }

        if (description) {
          const descriptionSuccess = description.dataset.success

          if (descriptionSuccess) {
            description.textContent = descriptionSuccess
          }
        }
      })

    }, false);

    const fancyboxElements = document.querySelectorAll('[data-fancybox]');

    fancyboxElements.forEach(function(element) {
      element.addEventListener('click', () => {
        forms?.forEach((form) => {
          form.classList.remove('success')
        })
      })
    });
  }

  handleCustomWorkSelect() {
    const containerSelect = document.querySelector('.work-select-wrap');
    const result = containerSelect?.querySelector('.work-select-result');
    const items = containerSelect?.querySelectorAll('.custom-work-select-value');

    containerSelect?.addEventListener('click', () => {
      containerSelect.classList.toggle('active');
    })

    items?.forEach((item) => {
      item.addEventListener('click', () => {
        item.classList.remove('active');

        if (result) {
          result.value = item.textContent;
        }
      })
    })
  }

  handleBackClick() {
    const currentHost = window.location.hostname;
    const referrer = document.referrer;
    const referrerHost = referrer ? new URL(referrer).hostname : null;

    if (referrer && referrerHost === currentHost) {
      console.log(1)
      window.history.back();
    } else {
      console.log(2)
      window.location.href = '/';
    }
  }

  handleButtonBack() {
    const buttons = document.querySelectorAll('.button-back');

    buttons?.forEach(button => {
      button.addEventListener('click', this.handleBackClick);
    });
  }
}

new Footer();